import { render, staticRenderFns } from "./Salaire.vue?vue&type=template&id=8ae9e734&scoped=true"
import script from "./Salaire.vue?vue&type=script&lang=js"
export * from "./Salaire.vue?vue&type=script&lang=js"
import style0 from "./Salaire.vue?vue&type=style&index=0&id=8ae9e734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae9e734",
  null
  
)

export default component.exports